import { render, staticRenderFns } from "./CreateMeetingModal.vue?vue&type=template&id=4b20492e&"
import script from "./CreateMeetingModal.vue?vue&type=script&lang=js&"
export * from "./CreateMeetingModal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports